import React from 'react'
import { Box } from '@hub/box'
import { HubStyleObject } from '@hub/design-system-base'
import { BasicPageContext } from '../../context'

const UtilityBox: React.FC<
  React.PropsWithChildren<{ sx?: HubStyleObject }>
> = ({ children, sx }): JSX.Element => (
  <BasicPageContext.Consumer>
    {isBasicPage =>
      !isBasicPage && (
        <Box sx={{ position: 'relative' }} data-test-id="utility-panel">
          <Box
            sx={{
              backgroundColor: 'surfaceBrandPrimary',
              padding: ['spacing-md', 'spacing-lg', 'spacing-xl', 'spacing-lg'],
              ...sx,
            }}
          >
            {children}
          </Box>
        </Box>
      )
    }
  </BasicPageContext.Consumer>
)

export default UtilityBox
